import type {VisualEmployee} from './OrdinaryWorkforceHome';

// These five names, existing role identifiers, and public titles were explicitly
// approved for the signed-out showcase. Never fetch private agent records,
// nicknames, memories, assignments, activity, or workspace profiles here.
const publicRoles=[
 ['praamis_executive','Praamis','Executive Operating Intelligence / AI COO','Executive'],
 ['workflow_operations_manager','Flow','Workflow Operations Manager','Workflow Operations'],
 ['content_production','Connie','Content Agent','Content'],
 ['revenue_director','Rev','Revenue Director / Chief Revenue Officer','Revenue'],
 ['engineering_director','Eli','Engineering Director & Lead Systems/Product Engineer','Engineering'],
] as const;

// Display-only IDs: NEVER canonical agent UUIDs. The original five agents
// remain in the private authenticated workspace without any data mutation.
export const verifiedPreviewEmployees:VisualEmployee[]=publicRoles.map(([roleKey,name,role,department])=>({
 id:'public-role-'+roleKey,
 roleKey,
 name,
 nickname:undefined,
 role,
 department,
 status:undefined,
 enabled:undefined,
}));
